import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./config/oauth";
import App from "./App";
import "./index.css";
import { initNativeShell } from "./lib/native-init";
import AppErrorBoundary from "./components/AppErrorBoundary";
import { installLinkGuard } from "./lib/linkGuard";

const msalInstance = new PublicClientApplication(msalConfig);

installLinkGuard();
initNativeShell();

ReactDOM.createRoot(document.getElementById("root")).render(
  <AppErrorBoundary>
    <HelmetProvider>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </HelmetProvider>
  </AppErrorBoundary>
);
